import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { IpAuthService } from '../../services/ip-auth.service';

@Component({
  selector: 'app-ip-title-mobile',
  templateUrl: './ip-title-mobile.component.html',
  styleUrls: ['./ip-title-mobile.component.scss']
})
export class IpTitleMobileComponent implements OnInit {
  @Input() title = '';
  @Input() btn: 'create' | 'filter' | 'other' | 'none' = 'none';
  @Input() btnText?: string;
  @Input() back = false;
  @Output() clicked = new EventEmitter<any>();
  mobile!:boolean;
  onlyRead: boolean = false;
  
  constructor(
    private location: Location,
    private authService: IpAuthService
  ) {}

  ngOnInit(): void {
    this.checkIfMobile()
    this.onlyRead = this.authService.isOnlyReadMode();
  }

  onClickButton(ev: MouseEvent) {
    this.clicked.emit(ev);
  }

  goBack() {
    this.location.back();
  }

  @HostListener('window:resize')
  checkIfMobile() {
    this.mobile = window.innerWidth < 768;
  }

}
